import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';
import { createSelectItem } from 'vet-bones/utils/select';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectModelsByIdSelector } from 'src/selectors/projectModelsById';

export const projectModelItemsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(projectModelsByIdSelector(projectId), (modelsById) =>
      Object.values(modelsById)
        .map((model) => createSelectItem(model.name, model.id))
        .sort(alphaSort((item) => item.text))
    )
);
